import React, { memo, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';

import styles from './ImgOneLine.module.less';
import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const codeList = [
  'recommend', // 首页
  'game', // 游戏频道
  'category', // 分类
  'topn', // 排行
  'wprecommend', // 壁纸推荐页面
  'arecommend', // 手游助手
  'acategory', // 安卓分类
  'update', // 软件升级
  'uninstall', // 我的软件
];

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const LOG_ACTION_SOURCE = {
    i_adx: `${logInfo.tag}_ADX`,
    c_action: `${logInfo.tag}_ADX`,
    source: `${logInfo.tag}_ADX`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
      });
    }
  }, [inView]);

  /**
   * 广告展示
   */
  useEffect(() => {
    const imgData = data && data.dataList[0];
    if (imgData) {
      dispatch(
        logging({
          category: 'I',
          action: LOG_ACTION_SOURCE.i_adx,
          label: '',
          param2: {
            source: LOG_ACTION_SOURCE.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word,
            adid: imgData.pageCardContentId,
          },
          param3: imgData.bizInfo,
        }),
      );
    }
  }, [dispatch, data]);

  const handleZtCard = useCallback(() => {
    const imgData = data.dataList[0];

    // 推荐页面banner点击打桩
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.c_action,
        label: '',
        param2: {
          source: LOG_ACTION_SOURCE.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          adid: imgData.pageCardContentId,
        },
        param3: imgData.bizInfo,
      }),
    );

    if (imgData.targetType === '1' || imgData.targetType === '3') {
      dispatch(
        logPostInfo({
          source_p: `${LOG_ACTION_SOURCE.source}||${imgData.pageCardContentId}`,
          source_pp: logInfoData.source_p,
        }),
      );
    }

    if (imgData.targetType === '1' && imgData.appInfo && imgData.appInfo.softID) {
      if (imgData.appInfo.androidType === '1') {
        history.push(
          `${CONTEXT}/adetail/${imgData.appInfo.packageName}/${
            imgData.appInfo.versionCode
          }/${imgData.appInfo.bizInfo || '{}'}`,
        );
      } else {
        history.push(
          `${CONTEXT}/detail/soft/${imgData.appInfo.softID || ''}/${imgData.appInfo.bizInfo ||
            '{}'}`,
        );
      }
    } else if (imgData.targetType === '2' && imgData.targetUrl) {
      window.open(imgData.targetUrl);
    } else if (imgData.targetType === '3' && imgData.ztId) {
      history.push(`${CONTEXT}/special?ztId=${imgData.ztId}&bannerId=${imgData.pageCardContentId}`);
    } else if (imgData.targetType === '4' && imgData.code && codeList.indexOf(imgData.code) > -1) {
      history.push(`${CONTEXT}/${imgData.code}`);
    } else if (imgData.targetType === '10' && imgData.advertCrid && imgData.advertUrl) {
      window.open(imgData.advertUrl);
    } else {
      history.push(`${CONTEXT}/error`);
    }
  }, []);

  return data && data.dataList ? (
    <div className={styles.card} ref={ref}>
      <img
        className={styles.card_img}
        src={data.dataList[0].contentImg}
        onClick={() => {
          handleZtCard();
        }}
      />
    </div>
  ) : (
    ''
  );
});
